// Grid layout constants
export const MIN_VISIBLE_ROWS = 200;
export const MIN_VISIBLE_COLS = 26;
export const EXTRA_SCROLL_ROWS = 60;
export const EXTRA_SCROLL_COLS = 8;

// Excel default column = 8.43 chars × 7px/char + 5px padding ≈ 64px
// Excel default row    = 15pt × (96/72) px/pt               ≈ 20px
export const DEFAULT_COL_WIDTH = 64;
export const DEFAULT_ROW_HEIGHT = 20;

// Keep minimums very small so narrow/short cells are not inflated
export const MIN_COL_WIDTH = 8;
export const MIN_ROW_HEIGHT = 4;

// Must match CSS .sev-grid-corner / tbody th width
export const HEADER_COL_WIDTH = 44;

// Approximate rendered height of the <thead> row (font-size:12px, line-height:1.4,
// padding:2+2, border:~1px).  Used by chart/image overlays to offset past the
// column-header row.  Set separately from DEFAULT_ROW_HEIGHT because the column
// header uses a fixed visual size that may differ from the data-row default.
export const HEADER_ROW_HEIGHT = 24;
